<template>
    <div v-show="isVisible" class="overlay" @click="onBackgroundClick">
        <div class="dialog" @click.stop>
            <h3>{{ lang($t(title)) }}</h3>
            <p>{{ lang($t(content)) }}</p>
            <div class="buttons">
                <a v-if="confirmUrl"
                   class="confirm-btn"
                   :href="confirmUrl"
                   target="_blank"
                   @click="onConfirm">
                    {{ lang($t("Confirm")) }}
                </a>

                <button v-else-if="showConfirm" class="confirm-btn" @click="onConfirm">
                    {{ lang($t("Confirm")) }}
                </button>


                <button v-if="showCancel" class="cancel-btn" @click="onCancel">{{ lang($t("Cancel")) }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import {common} from "@mixins/common";

export default {
    name: "ConfirmDialog",
    mixins: [common],
    props: {
        title: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            required: true
        },
        showConfirm: {
            type: Boolean,
            default: true
        },
        showCancel: {
            type: Boolean,
            default: true
        },
        confirmUrl: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            isVisible: this.value,
        };
    },
    watch: {
        value(newVal) {
            this.isVisible = newVal;
        }
    },
    methods: {
        closeDialog() {
            this.$emit("input", false);
        },
        onConfirm() {
            this.$emit('confirm');
            this.closeDialog();
            // if (!this.confirmUrl) {
            //
            // }
        },
        onCancel() {
            this.$emit('cancel');
            this.closeDialog();
        },
        onBackgroundClick() {
            this.closeDialog();
        }
    }
}
</script>

<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.dialog {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 300px;
    text-align: center;
}

.dialog h3 {
    margin-bottom: 15px !important;
    font-size: 20px;
}

.dialog p {
    margin-bottom: 20px;
    line-height: 1.5;
    font-size: 16px;
}

/* 按鈕容器 */
.buttons {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    gap: 10px; /* 增加按鈕間距 */
}

/* 按鈕基礎樣式 */
button {
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
    border: none;
    transition: all 0.3s ease-in-out;
}

.confirm-btn {
    /*background-color: #007bff;*/
    /*color: white;*/
    /*box-shadow: 0 4px 6px rgba(0, 123, 255, 0.2);*/
    display: inline-block;
    text-align: center;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
    border: none;
    transition: all 0.3s ease-in-out;
    text-decoration: none;
    background-color: #007bff;
    color: white;
    box-shadow: 0 4px 6px rgba(0, 123, 255, 0.2);
}

.confirm-btn:hover {
    background-color: #0056b3;
}

.cancel-btn {
    background-color: #e0e0e0;
    color: #333;
}

.cancel-btn:hover {
    background-color: #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ConfirmDialog.vue